import { useRef } from "react";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import CategoryShow from "./CategoryShow";
function Box() {
  const ref = useRef(null);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  return (
    <div className="w-full p-5 border border-gray-200 rounded-xl shadow-sm mb-8">
      <div className="flex space-x-6">
        <div className="w-1/2">
          <h1 className="h1-bold">Kategori Pilihan</h1>
          <div className="relative">
            <button
              onClick={() => scroll(-200)}
              className="absolute top-1/3 -left-4 p-2 border rounded-full bg-white shadow-lg hover:shadow-xl"
            >
              <ChevronLeftIcon className="h-5" />
            </button>
            <button
              onClick={() => scroll(200)}
              className="absolute top-1/3 -right-4 p-2 border rounded-full bg-white shadow-lg hover:shadow-xl"
            >
              <ChevronRightIcon className="h-5" />
            </button>
            <div
              className="flex items-center space-x-4 overflow-x-scroll my-7 scrollbar-hide overscroll-contain"
              ref={ref}
            >
              <div className=" w-32 h-full cursor-pointer flex-shrink-0 ">
                <img
                  src="https://images.tokopedia.net/img/cache/200-square/attachment/2018/8/9/3127195/3127195_76d08c44-8194-4454-9fb0-1e7a64b656aa.jpg.webp?ect=4g"
                  alt=""
                  className="rounded-md border border-gray-200"
                />
              </div>
              <div className=" w-32 h-32 cursor-pointer flex-shrink-0 ">
                <img
                  src="https://images.tokopedia.net/img/cache/200-square/attachment/2018/8/9/3127195/3127195_76d08c44-8194-4454-9fb0-1e7a64b656aa.jpg.webp?ect=4g"
                  alt=""
                  className="rounded-md border border-gray-200"
                />
              </div>
              <div className=" w-32 h-32 cursor-pointer flex-shrink-0 ">
                <img
                  src="https://images.tokopedia.net/img/cache/200-square/attachment/2018/8/9/3127195/3127195_c6f70915-577f-4cd4-834c-daf892265ef0.jpg.webp?ect=4g"
                  alt=""
                  className="rounded-md border border-gray-200"
                />
              </div>
              <div className=" w-32 h-32 cursor-pointer flex-shrink-0 ">
                <img
                  src="https://images.tokopedia.net/img/cache/200-square/attachment/2018/8/9/3127195/3127195_c6f70915-577f-4cd4-834c-daf892265ef0.jpg.webp?ect=4g"
                  alt=""
                  className="rounded-md border border-gray-200"
                />
              </div>
              <div className=" w-32 h-32 cursor-pointer flex-shrink-0 ">
                <img
                  src="https://images.tokopedia.net/img/cache/200-square/attachment/2018/8/9/3127195/3127195_c6f70915-577f-4cd4-834c-daf892265ef0.jpg.webp?ect=4g"
                  alt=""
                  className="rounded-md border border-gray-200"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-1/2">
          <div className="flex space-x-2 items-end">
            <h1 className="h1-bold">Top Up & Tagihan</h1>
            <p className="font-semibold text-tokped_green text-lg cursor-pointer hover:text-green-600">
              Lihat Semua
            </p>
          </div>
          <div className="border rounded-lg my-7">
            <div className="flex items-center border-b-2 cursor-pointer">
              <h1 className="font-bold text-tokped_green border-b-2 border-tokped_green px-7 py-2">
                Pulsa
              </h1>
              <h1 className="tab-link">Paket Data</h1>
              <h1 className="tab-link">Listrik PLN</h1>
              <h1 className="tab-link border-r">Flight</h1>
              <DotsVerticalIcon className="h-5 mx-auto text-gray-500" />
            </div>
            <div className="p-4 flex space-x-3 items-end">
              <div className="flex flex-col">
                <label
                  htmlFor="nomor"
                  className="text-sm text-gray-600 font-semibold"
                >
                  Nomor Telepon
                </label>
                <input
                  type="text"
                  id="nomor"
                  placeholder="085877750650"
                  className="border border-gray-300 focus:outline-none rounded-lg mt-2 p-2 px-4 flex-grow focus:border-tokped_green text-sm text-gray-400"
                />
              </div>
              <div className="flex flex-col relative">
                <label
                  htmlFor="nominal"
                  className="text-sm text-gray-600 font-semibold"
                >
                  Nominal
                </label>
                <input
                  type="text"
                  id="nominal"
                  className="border bg-gray-300 focus:outline-none rounded-lg mt-2 p-2 px-4 flex-grow  text-sm text-gray-400"
                />
              </div>
              <div className="w-full">
                <button className="p-2 px-5 rounded-lg bg-gray-300 w-full text-gray-800 font-medium">
                  Beli
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <CategoryShow />
      </div>
    </div>
  );
}

export default Box;
